const drupalSettings = window.drupalSettings || {};

const config = {
  mode:  window.drupalSettings?.ios_settings?.mode || "normal"
};

/**
 * UID for Airwallex SCA embedded init. When masquerading, prefer the real
 * account (masquerade_source_uid from naut_react_js_settings_alter).
 */
function getScaInitUid() {
  const u = drupalSettings?.user;
  if (!u) {
    return undefined;
  }
  return (
    u.masquerade_source_uid ??
    u.user_id ??
    u.userId ??
    u.uid
  );
}

export { config, drupalSettings, getScaInitUid };